import { FeatureFlagged } from '@backstage/core-app-api';
import { Entity, RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntityLayout, RelatedEntitiesCard } from '@backstage/plugin-catalog';
import { EntityTable, useEntity } from '@backstage/plugin-catalog-react';
import { EntityDomainPageAboutCard } from '@internal/plugin-domain-page-about-card';
import { Grid } from '@material-ui/core';
import React from 'react';
import CustomizedSystemPage from '../../../pages/CustomizedSystemPage';
import ADRList from '../../../pages/Adr';
import { CustomDomainEntityLayout } from '../../../pages/EntityLayout/CustomDomainEntityLayout';
import CustomLinks from '../../../pages/Links';
import CoownersTeams from '../../../pages/ContributingTeam/ContributingTeams';
import { techdocsContent } from '../content/techdocsContent';
import GraphCard from '../../EntityCatalogGraphCard';
import ProductSecurity from '@internal/backstage-plugin-product-security/src/components/Product-Security';

const isDocsAvailable = (entity: any) =>
  Boolean(entity?.metadata?.annotations?.['backstage.io/techdocs-ref']?.includes('https://'));

const isAdrAvailable = (entity: any) =>
  Boolean(entity?.metadata?.annotations?.['backstage.io/adr-location']?.includes('https://'));

export const CapabilityProductBoundaryComponentsCard = () => (
  <>
    <CustomizedSystemPage type="Component" />
    <CustomizedSystemPage type="api" />
    <CustomizedSystemPage type="Resource" />
  </>
);

export const BusinessComponentsCard = () => (
  <>
    <CustomizedSystemPage type="Notification" />
    <br />
    <CustomizedSystemPage type="Online Content" />
  </>
);

export const SystemCapabilitiesCard = () => (
  <RelatedEntitiesCard<Entity>
    variant="gridItem"
    title="Capabilities"
    entityKind="capability"
    relationType={RELATION_HAS_PART}
    columns={[
      EntityTable.columns.createEntityRefColumn<Entity>({
        defaultKind: 'Capability',
      }),
    ]}
    asRenderableEntities={(entities: Entity[]) => entities as Entity[]}
    emptyMessage="No capabilities found"
    emptyHelpLink="No Capabilities are linked to this System."
  />
);



export const overviewSystemPage = (
  entityWarningContent?: JSX.Element,
) => {

  return (
    <CustomDomainEntityLayout >
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
          <Grid item md={6} xs={12}>
            <FeatureFlagged with="about-card">
              <EntityDomainPageAboutCard variant="gridItem" from="default" />
            </FeatureFlagged>
            <FeatureFlagged without="about-card">
              <EntityDomainPageAboutCard variant="gridItem" from="default" />
            </FeatureFlagged>
          </Grid>
          <Grid item md={6} xs={12}>
            <GraphCard isDefault height={400}/>
          </Grid>
          <Grid item md={6} xs={12}>
              <SystemCapabilitiesCard />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomLinks 
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <CoownersTeams 
            />
          </Grid> 
        </Grid>
      </EntityLayout.Route>

      <EntityLayout.Route path="/component" title="Tech Components">
        <CapabilityProductBoundaryComponentsCard />
      </EntityLayout.Route>
      {
       <EntityLayout.Route path="/businessComponents" title="Business Components">
        <BusinessComponentsCard />
      </EntityLayout.Route>
      }
      
        <EntityLayout.Route if={isDocsAvailable} path="/docs" title="Docs">
        {techdocsContent}
      </EntityLayout.Route>
       
      <EntityLayout.Route if={isAdrAvailable} path="/adr" title="ADR">
        <ADRList />
      </EntityLayout.Route>

      <EntityLayout.Route
        path="/product-security"
        title="Product Security"
      >
        <ProductSecurityWrapper />
      </EntityLayout.Route>
    
    </CustomDomainEntityLayout>
  );
};



const ProductSecurityWrapper=()=>{
  const { entity } = useEntity();
  return <ProductSecurity appName={`system:default/${entity?.metadata?.name}`} />;
}

export const systemPage = overviewSystemPage();
export const ProductSecurityPage = <ProductSecurityWrapper />;